var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"show-navigation":false}},[_c('div',{staticClass:"col ma-register"},[_c('div',{staticClass:"panel clearfix"},[_c('h1',[_vm._v("Wachtwoord opvragen")]),_vm._v(" "),_c('forgot-password-form')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-704a28a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ForgotPasswordPage.vue
// module id = MF/D
// module chunks = 1